import type React from 'react';
import type { AmenitySubGroup } from '../utils/amenityGrouping';
import {
  ClimateIcon,
  CommunityIcon,
  ConnectivityIcon,
  FacilitiesIcon,
  FitnessIcon,
  FurnishingIcon,
  InteriorIcon,
  KitchenIcon,
  LaundryIcon,
  LeaseIcon,
  OutdoorIcon,
  ParkingIcon,
  PetFacilitiesIcon,
  PetPolicyIcon,
  ScenicViewsIcon,
  SecurityIcon,
  ServicesIcon,
  SmokingIcon,
  SocialIcon,
  SpecialFeaturesIcon,
  UtilitiesIcon,
} from 'app/shared/halo/components/ui/icons';

type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

const SUB_GROUP_ICONS: Partial<Record<AmenitySubGroup, React.FC<IconProps>>> = {
  Kitchen: KitchenIcon,
  Laundry: LaundryIcon,
  Climate: ClimateIcon,
  'Interior features': InteriorIcon,
  Connectivity: ConnectivityIcon,
  'Outdoor spaces': OutdoorIcon,
  'Scenic views': ScenicViewsIcon,
  Parking: ParkingIcon,
  Facilities: FacilitiesIcon,
  'Pet facilities': PetFacilitiesIcon,
  Security: SecurityIcon,
  'Fitness and sports': FitnessIcon,
  'Social and work spaces': SocialIcon,
  Services: ServicesIcon,
  'Lease terms': LeaseIcon,
  'Community type': CommunityIcon,
  'Pet policy': PetPolicyIcon,
  'Parking policy': ParkingIcon,
  'Utilities included': UtilitiesIcon,
  Smoking: SmokingIcon,
  Furnishing: FurnishingIcon,
  'Special features': SpecialFeaturesIcon,
};

export const getSubGroupIcon = (subGroup: AmenitySubGroup): React.ReactElement | null => {
  const IconComponent = SUB_GROUP_ICONS[subGroup];
  if (!IconComponent) return null;
  return <IconComponent size="18" />;
};
